/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import { computed, getCurrentInstance } from '@vue/composition-api';

function useFormDisabled() {
  var formDisabled = computed(function () {
    var currentInstance = getCurrentInstance();
    var parent = currentInstance.parent;

    while (parent) {
      if (parent.proxy.$options.name === "TForm") {
        return parent.props.disabled;
      }

      parent = parent.parent;
    }

    return false;
  });
  return {
    formDisabled: formDisabled
  };
}

export { useFormDisabled as default };
//# sourceMappingURL=useFormDisabled.js.map
